module.exports = __webpack_public_path__ + "img/James Whitehurst on Board of Visitors, 1972.e0a949f2.jpg";